import React, { useEffect } from 'react'
import type { ReactNode } from 'react'
import { useAuthStore } from '@/stores/useAuthStore'
import { LANDING_URL } from '@/config/env'

interface PrivateRouteProps {
  children: ReactNode
}

/**
 * Guard for private routes
 * Redirects to LANDING_URL if there's no access token
 */
const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const token = useAuthStore((state) => state.accessToken)

  useEffect(() => {
    if (!token) {
      window.location.href = LANDING_URL
    }
  }, [token])

  return token ? <>{children}</> : null
}

export default PrivateRoute
